import { createFileRoute } from "@tanstack/react-router";
import type * as React from "react";

import {
  type ConsoleFlowDetailMode,
  ConsoleFlowDetailPage,
  consoleFlowDetailQueryOptions,
  consoleFlowPaletteQueryOptions,
  consoleFlowStatsQueryOptions,
} from "@/features/console";

/** URL state: which mode is showing + which run is reopened in "Utilizza". */
interface FlowDetailSearch {
  readonly mode?: ConsoleFlowDetailMode;
  readonly run?: string;
}

export const Route = createFileRoute("/_authed/_modal/console/flows/$flowId")({
  validateSearch: (search: Record<string, unknown>): FlowDetailSearch => ({
    mode: search.mode === "utilizza" || search.mode === "modifica" ? search.mode : undefined,
    run: typeof search.run === "string" && search.run.length > 0 ? search.run : undefined,
  }),
  loader: ({ context: { queryClient }, params }) => {
    void queryClient.ensureQueryData(consoleFlowDetailQueryOptions(params.flowId));
    // The stats card is above the fold on the detail view — warm it too.
    void queryClient.ensureQueryData(consoleFlowStatsQueryOptions(params.flowId));
    // The editor can't paint the canvas without the node catalog.
    void queryClient.ensureQueryData(consoleFlowPaletteQueryOptions());
  },
  component: FlowDetailRoute,
});

function FlowDetailRoute(): React.ReactElement {
  const { flowId } = Route.useParams();
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <ConsoleFlowDetailPage
      flowId={flowId}
      mode={search.mode}
      focusRunId={search.run}
      onModeChange={(mode) => void navigate({ search: (prev) => ({ ...prev, mode }) })}
      onFocusRun={(run) => void navigate({ search: (prev) => ({ ...prev, run }) })}
      onClearFocus={() => void navigate({ search: (prev) => ({ ...prev, run: undefined }) })}
    />
  );
}
